import {
  FETCH_HOSPITAL_SYSTEM_START,
  FETCH_HOSPITAL_SYSTEM_SUCCESS,
  FETCH_HOSPITAL_SYSTEM_FAILURE,
} from '../constants/hospitalSystemsActionsTypes';

const initialState = {
  instance: {},
  isStarted: false,
  isLoad: false,
  isError: false,
  msg: null,
};

function hospitalSystem(state = initialState, action) {
  switch (action.type) {
    case FETCH_HOSPITAL_SYSTEM_START:
      return {
        ...state,
        isStarted: true,
        isLoad: false,
        isError: false,
        msg: null,
      };
    case FETCH_HOSPITAL_SYSTEM_SUCCESS:
      return {
        ...state,
        instance: action.payload,
        isStarted: false,
        isLoad: true,
        isError: false,
      };
    case FETCH_HOSPITAL_SYSTEM_FAILURE:
      return {
        ...state,
        instance: {},
        isStarted: false,
        isLoad: true,
        isError: true,
        msg: action.payload,
      };
    default:
      return state;
  }
}

export default hospitalSystem;
